import React from "react";
import { motion } from "framer-motion";

const lineItems = [
  {
    name: "Asha software & platform",
    description:
      "PMS / continuous integration · Communications · Marketing · eClaims · Revenue intelligence · Insurance verification · Payments · Patient portal · Online scheduling",
    price: "$1,499",
    unit: "/ location / month",
  },
  {
    name: "Baseline AI package",
    description:
      "All 21 AI products — front-office, back-office, and clinical & intelligence — included. Comes with 100,000 AI credits / location / month.",
    price: "$499",
    unit: "/ location / month",
  },
];

const AshaAbrahamPricingSlide = () => {
  return (
    <div className="h-full w-full bg-[#f8fafc] flex items-center justify-center p-6 xl:p-10 relative overflow-hidden font-sans">
      {/* Ambient gradient blurs */}
      <div
        className="absolute top-[-200px] right-[-100px] w-[700px] h-[700px] rounded-full blur-[120px] opacity-25 pointer-events-none"
        style={{ background: "linear-gradient(135deg, #93c5fd 0%, #c4b5fd 50%, #fbcfe8 100%)" }}
      />
      <div
        className="absolute bottom-[-200px] left-[-100px] w-[600px] h-[600px] rounded-full blur-[120px] opacity-20 pointer-events-none"
        style={{ background: "linear-gradient(135deg, #a5f3fc 0%, #93c5fd 50%, #c4b5fd 100%)" }}
      />
      <div className="absolute inset-0 bg-[radial-gradient(#cbd5e1_0.8px,transparent_0.8px)] [background-size:28px_28px] opacity-40 pointer-events-none" />

      <div className="w-full max-w-[1040px] z-10 relative">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="mb-7"
        >
          <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-slate-500 mb-2">
            Pricing
          </p>
          <h2 className="text-3xl lg:text-[40px] font-bold text-slate-900 tracking-tight leading-tight">
            All-in pricing for{" "}
            <span className="bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
              Abraham Dental.
            </span>
          </h2>
          <p className="text-[14px] text-slate-600 mt-2">
            Flat per-location monthly rate across all 5 Abraham Dental
            locations. Billed in advance, per location.
          </p>
        </motion.div>

        {/* Pricing table */}
        <motion.table
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="w-full"
        >
          <thead>
            <tr className="border-t border-b border-slate-200">
              <th className="text-left py-3 text-[11px] font-bold uppercase tracking-[0.14em] text-slate-500">
                Item
              </th>
              <th className="text-right py-3 text-[11px] font-bold uppercase tracking-[0.14em] text-slate-500 w-[260px]">
                Price
              </th>
            </tr>
          </thead>
          <tbody>
            {lineItems.map((row) => (
              <tr key={row.name} className="border-b border-slate-200 align-top">
                <td className="py-4 pr-8">
                  <div className="text-[16px] font-semibold text-slate-900 leading-snug">
                    {row.name}
                  </div>
                  <div className="text-[13px] text-slate-500 leading-relaxed mt-1.5 max-w-[640px]">
                    {row.description}
                  </div>
                </td>
                <td className="py-4 text-right whitespace-nowrap">
                  <div className="text-[20px] font-semibold text-slate-900 leading-none">
                    {row.price}
                  </div>
                  <div className="text-[12px] text-slate-500 mt-1.5">
                    {row.unit}
                  </div>
                </td>
              </tr>
            ))}
            {/* Base total row */}
            <tr className="border-b-2 border-slate-900 align-top bg-slate-50/40">
              <td className="py-4 pr-8">
                <div className="text-[11px] font-bold uppercase tracking-[0.14em] text-slate-500">
                  Total
                </div>
                <div className="text-[17px] font-semibold text-slate-900 leading-snug mt-1">
                  Per location, all-in
                </div>
              </td>
              <td className="py-4 text-right whitespace-nowrap">
                <div className="text-[28px] font-bold text-slate-900 leading-none tracking-tight">
                  $1,998
                </div>
                <div className="text-[12px] text-slate-500 mt-1.5">
                  / location / month
                </div>
              </td>
            </tr>
          </tbody>
        </motion.table>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="text-[12.5px] text-slate-500 leading-relaxed mt-5"
        >
          Special exceptions and discounts applied to this engagement are
          itemized on the next slide.
        </motion.p>
      </div>
    </div>
  );
};

export default AshaAbrahamPricingSlide;
